import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import ReactGA from 'react-ga4';

// Suppress CRA dev-overlay false alarm: ResizeObserver fires a benign
// "loop completed with undelivered notifications" warning during fast layout
// thrash (e.g. route changes with active ResizeObservers). It's not a real
// error — browsers ignore it, production ignores it, but the webpack-dev
// overlay treats it as fatal and shows a red screen. Swallow it here.
if (process.env.NODE_ENV !== 'production') {
  const RO_MSG = /ResizeObserver loop (completed with undelivered notifications|limit exceeded)/;
  window.addEventListener('error', (e) => {
    if (e && e.message && RO_MSG.test(e.message)) {
      e.stopImmediatePropagation();
      e.preventDefault();
    }
  });
  window.addEventListener('unhandledrejection', (e) => {
    const msg = e && e.reason && (e.reason.message || String(e.reason));
    if (msg && RO_MSG.test(msg)) {
      e.stopImmediatePropagation();
      e.preventDefault();
    }
  });
}

const ga4_id = process.env.REACT_APP_GA || process.env.GA_MEASUREMENT_ID;

const initializeGA = () => {
  if (!ga4_id) {
      console.error("GA Measurement ID is not set. Please check your .env file.");
      return;
  }

  ReactGA.initialize(ga4_id);
  ReactGA.send({ hitType: "pageview", page: window.location.pathname + window.location.search });
};

initializeGA();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

